module.exports = __webpack_public_path__ + "img/WinLose1.ccc67e5d.png";